import { ScanVia } from "@/models/assetScan/AssetScanTypes";
import { isValidAssetTag } from "@/models/assetScan/assetTag";

export interface TagRead {
  tag?: string;
  /** Serial number of the NFC tag; present even when the tag carries no data yet. */
  serial?: string;
  via: ScanVia;
  /** What the reader saw, for the diagnosis view during the test period. */
  raw?: string[];
}

/** The part of a Web NFC record we read; matches `NDEFRecord`. */
export interface NdefRecordLike {
  recordType: string;
  encoding?: string;
  data?: DataView;
}

const TAG_IN_TEXT = /FF-A:[A-Za-z0-9-]{1,32}/;

function safeDecodeUri(text: string): string {
  try {
    return decodeURIComponent(text);
  } catch {
    return text;
  }
}

/** A tag typed in, read from a QR code or a link: the tag itself or a URL that ends in it. */
export function tagFromText(text: string): string | undefined {
  const match = safeDecodeUri(text.trim()).match(TAG_IN_TEXT)?.[0];
  return match && isValidAssetTag(match) ? match : undefined;
}

export function decodeNdefRecord(record: NdefRecordLike): string {
  if (!record.data) return "";
  return new TextDecoder(record.encoding || "utf-8").decode(record.data);
}

/** The first text or URL record that holds one of our tags. */
export function tagFromNdefRecords(records: NdefRecordLike[]): string | undefined {
  for (const record of records) {
    if (record.recordType !== "text" && record.recordType !== "url") continue;
    const tag = tagFromText(decodeNdefRecord(record));
    if (tag) return tag;
  }
  return undefined;
}
